import { Route, Routes } from 'react-router-dom';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import AdminLayout from './components/AdminLayout/AdminLayout';
import Articles from './components/Articles/Articles';
import Services from './components/Services/Services';
import Ekibimiz from './components/Ekibimiz/Ekibimiz';
import FAQ from './components/FAQ/FAQ';
import News from './components/News/News';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      
      {/* Admin Rotaları - Layout ile Sarmalanmış */}
      <Route path="/admin/dashboard" element={
        <AdminLayout>
          <Dashboard /> {/* Dashboard sayfan buraya children olarak gider */}
        </AdminLayout>
      } />
      
      <Route path="/admin/articles" element={
        <AdminLayout>
          <Articles/>
        </AdminLayout>
      } />

         <Route path="/admin/services" element={
        <AdminLayout>
          <Services/>
        </AdminLayout>
      } />

         <Route path="/admin/ekibimiz" element={
        <AdminLayout>
          <Ekibimiz/>
        </AdminLayout>
      } />

         <Route path="/admin/faq" element={
        <AdminLayout>
          <FAQ/>
        </AdminLayout>
      } />

            <Route path="/admin/news" element={
        <AdminLayout>
          <News/>
        </AdminLayout>
      } />
      
    </Routes>
  );
}
export default App;